import Vue from 'vue';
import Vuex from 'vuex';
import Api from '@/api';
import filterObject from '@/util/lang';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    products: JSON.parse(localStorage.getItem('products')),
    currentProduct: {},
    lang: 'en',
  },
  mutations: {
    setCurrentProducts(state, id) {
      state.currentProduct = state.products.find(el => el._id === id);
    },
    setProducts(state, products) {
      state.products = products;
    },
    setLang(state, lang) {
      state.lang = lang;
    },
  },
  actions: {
    getProducts({ commit }) {
      return Api.getAllProducts()
        .then(({ data: { entries } }) => {
          return entries.map(el => filterObject(el, this.getters.lang));
        })
        .then(entries => {
          commit('setProducts', entries);
          if (store.state.currentProduct) {
            store.commit('setCurrentProducts', store.state.currentProduct._id);
          }
          localStorage.setItem('products', JSON.stringify(entries));
        });
    },
  },
  getters: {
    lang: state => state.lang,
    products: state => state.products,
    brands: state =>
      state.products
        .reduce((acc, { brand }) => {
          if (acc.indexOf(brand) === -1) {
            acc.push(brand);
          }
          return acc;
        }, [])
        .sort(),
    countryOfProduction: state =>
      state.products
        .reduce((acc, { country_of_production }) => {
          if (acc.indexOf(country_of_production) === -1) {
            acc.push(country_of_production);
          }
          return acc;
        }, [])
        .sort(),
    category: state =>
      state.products
        .reduce((acc, { category }) => {
          if (acc.indexOf(category) === -1) {
            acc.push(category);
          }
          return acc;
        }, [])
        .sort(),
    continent: state =>
      state.products
        .reduce((acc, { continent }) => {
          if (acc.indexOf(continent) === -1) {
            acc.push(continent);
          }
          return acc;
        }, [])
        .sort(),
    region: state =>
      state.products.reduce((acc, { region }) => {
        let regionArr;
        if (/\//.test(region)) {
          regionArr = region.split('/');
        }
        if (regionArr) {
          regionArr.forEach(regionFromArray => {
            const trimRegionFromArray = regionFromArray.trim();
            if (acc.indexOf(trimRegionFromArray) === -1) {
              acc.push(trimRegionFromArray);
            }
          });
          return acc;
        }
        if (acc.indexOf(region) === -1) {
          acc.push(region);
        }
        return acc;
      }, []),
    currentProduct: state => state.currentProduct,
  },
});

store.watch(
  state => state.lang,
  () => {
    store.dispatch('getProducts');
  },
);

export default store;
